function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#fff;}"));

var _ref3 = /*#__PURE__*/React.createElement("path", {
  className: "cls-1",
  d: "M27.601,37.97H11.004c-5.756,0-10.44-4.683-10.44-10.44V10.934C.565,5.177,5.248.494,11.004.494h16.597c5.757,0,10.44,4.683,10.44,10.44v16.597c0,5.757-4.683,10.44-10.44,10.44ZM11.004,3.857c-3.902,0-7.077,3.175-7.077,7.077v16.597c0,3.902,3.175,7.077,7.077,7.077h16.597c3.902,0,7.077-3.175,7.077-7.077V10.934c0-3.902-3.175-7.077-7.077-7.077H11.004Z"
});

var _ref4 = /*#__PURE__*/React.createElement("rect", {
  className: "cls-1",
  x: 43.782,
  y: 2.175,
  width: 34.113,
  height: 34.113,
  rx: 8.758,
  ry: 8.758
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  className: "cls-1",
  d: "M27.601,79.506H11.004c-5.756,0-10.44-4.683-10.44-10.44v-16.597c0-5.757,4.683-10.44,10.44-10.44h16.597c5.757,0,10.44,4.683,10.44,10.44v16.597c0,5.756-4.683,10.44-10.44,10.44ZM11.004,45.393c-3.902,0-7.077,3.175-7.077,7.077v16.597c0,3.902,3.175,7.077,7.077,7.077h16.597c3.902,0,7.077-3.175,7.077-7.077v-16.597c0-3.902-3.175-7.077-7.077-7.077H11.004Z"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  className: "cls-1",
  d: "M27.601,0H11.004C4.975,0,.071,4.905.071,10.934v16.596c0,6.029,4.905,10.934,10.934,10.934h16.597c6.029,0,10.934-4.905,10.934-10.934V10.934C38.535,4.905,33.63,0,27.601,0ZM34.184,27.53c0,3.63-2.953,6.583-6.583,6.583H11.004c-3.63,0-6.583-2.953-6.583-6.583V10.934c0-3.63,2.953-6.583,6.583-6.583h16.597c3.63,0,6.583,2.953,6.583,6.583v16.596Z"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  className: "cls-1",
  d: "M27.601,41.536H11.004C4.975,41.536.071,46.441.071,52.469v16.597c0,6.029,4.905,10.934,10.934,10.934h16.597c6.029,0,10.934-4.905,10.934-10.934v-16.597c0-6.029-4.905-10.934-10.934-10.934ZM34.184,69.067c0,3.629-2.953,6.583-6.583,6.583H11.004c-3.63,0-6.583-2.953-6.583-6.583v-16.597c0-3.629,2.953-6.583,6.583-6.583h16.597c3.63,0,6.583,2.953,6.583,6.583v16.597Z"
});

var _ref8 = /*#__PURE__*/React.createElement("path", {
  className: "cls-1",
  d: "M69.137,41.536h-16.597c-6.029,0-10.934,4.905-10.934,10.934v16.597c0,6.029,4.905,10.934,10.934,10.934h16.597c6.029,0,10.933-4.905,10.933-10.934v-16.597c0-6.029-4.905-10.934-10.933-10.934ZM75.72,69.067c0,3.629-2.953,6.583-6.583,6.583h-16.597c-3.63,0-6.583-2.953-6.583-6.583v-16.597c0-3.629,2.953-6.583,6.583-6.583h16.597c3.63,0,6.583,2.953,6.583,6.583v16.597Z"
});

var _ref9 = /*#__PURE__*/React.createElement("path", {
  className: "cls-1",
  d: "M69.137,79.506h-16.597c-5.756,0-10.44-4.683-10.44-10.44v-16.597c0-5.757,4.683-10.44,10.44-10.44h16.597c5.757,0,10.44,4.683,10.44,10.44v16.597c0,5.756-4.683,10.44-10.44,10.44ZM52.541,45.393c-3.902,0-7.077,3.175-7.077,7.077v16.597c0,3.902,3.175,7.077,7.077,7.077h16.597c3.902,0,7.077-3.175,7.077-7.077v-16.597c0-3.902-3.175-7.077-7.077-7.077h-16.597Z"
});

var SvgNavDashboard01 = function SvgNavDashboard01(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    viewBox: "0 0 80 80",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgNavDashboard01, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/nav_dashboard01.aae4dfb6.svg";
export { ForwardRef as ReactComponent };